// desktop.module.state.js

"use strict";


stateController.$inject = ['$scope', '$state', '$location'];


function stateController($scope, $state, $location){


    

    let bx = window.BX;
    bx.addCustomEvent('onDesktopMenuLoaded', bx.delegate(function (menu) {

        var path = $location.$$path.substr(1);
    


            var matchedState,
            states = $state.get();
            for (var i = 0; i < states.length; i++) {
                var state = states[i];
                if (state.abstract) {
                    continue; }

                var privatePortion = state.$$state();
                var match = privatePortion.url.exec(path);
                if (match) {
                    matchedState = { state: state, stateParams: match };
                    break;
                }
            }


          

            if (matchedState) {
                setTimeout(function(){
                    if(matchedState.state.name.indexOf('.')>0){
                        
                        $state.go(matchedState.state.name.split('.')[0], matchedState.stateParams)
                    }else{
                        $state.go(matchedState.state, matchedState.stateParams)
                    }
                },1);
                return;
            }

            let currentState = menu.find(obj => {
                if(obj.fullUrl){
                    return obj.fullUrl === path
                }
                return obj.url === path
            })
   
            if(currentState){
                $state.go(currentState.name);
            }else if(!path){
                $state.go('desktop.index');
            }

          

            window.currentState = currentState ;

      
/*
        window.state = state ;
        window.scope = scope ;
        window.menu=menu;
        window.loc = $location;
  */      
    }),this);

}

export { stateController };



// WEBPACK FOOTER //
// ./src/components/desktop/desktop.module.state.js